// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ToriGate from '../_raw/ui/icon_tori_gate.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ToriGate);
